import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../utils/api'
import { useCart } from '../context/CartContext'

function Home() {
  const [featuredProducts, setFeaturedProducts] = useState([])
  const [categories, setCategories] = useState([])
  const [currentSlide, setCurrentSlide] = useState(0)
  const slideInterval = useRef()

  const { addToCart } = useCart()

  useEffect(() => {
    loadFeaturedProducts()
    loadCategories()
  }, [])

  useEffect(() => {
    startAutoSlide()
    return () => clearInterval(slideInterval.current)
  }, [featuredProducts])

  const loadFeaturedProducts = async () => {
    try {
      const products = await api.getProducts()
      const featured = products.filter(product => product.featured).slice(0, 5)
      setFeaturedProducts(featured)
    } catch (error) {
      console.error('Failed to load featured products:', error)
    }
  }

  const loadCategories = async () => {
    try {
      const categoriesData = await api.getCategories()
      setCategories(categoriesData)
    } catch (error) {
      console.error('Failed to load categories:', error)
    }
  }

  const startAutoSlide = () => {
    clearInterval(slideInterval.current)
    slideInterval.current = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % featuredProducts.length)
    }, 4000)
  }

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % featuredProducts.length)
    startAutoSlide()
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + featuredProducts.length) % featuredProducts.length)
    startAutoSlide()
  }

  return (
    <div>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1>Welcome to ShopCloud</h1>
          <p>Discover amazing products at great prices</p>
          <Link to="/products" className="btn btn-large">Shop Now</Link>
        </div>
      </section>

      {/* Featured Products Carousel */}
      {featuredProducts.length > 0 && (
        <section className="featured-section">
          <div className="container">
            <h2>Featured Products</h2>
            <div className="carousel">
              <button className="carousel-btn carousel-btn-prev" onClick={prevSlide}>‹</button>
              
              <div className="carousel-track">
                {featuredProducts.map((product, index) => (
                  <div
                    key={product.id}
                    className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                  >
                    <div className="featured-product">
                      <img
                        src={product.image || '/placeholder-image.jpg'}
                        alt={product.name}
                        onError={(e) => {
                          e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgZmlsbD0iI2Y0ZjRmNCIvPjx0ZXh0IHg9IjEwMCIgeT0iMTAwIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTQiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIGZpbGw9IiM5OTkiPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg==';
                        }}
                      />
                      <div className="featured-product-info">
                        <h3>{product.name}</h3>
                        <p className="price">${product.price}</p>
                        <p>{product.description}</p>
                        <button
                          className="btn"
                          onClick={() => addToCart(product)}
                        >
                          Add to Cart
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              
              <button className="carousel-btn carousel-btn-next" onClick={nextSlide}>›</button>
              
              <div className="carousel-indicators">
                {featuredProducts.map((_, index) => (
                  <button
                    key={index}
                    className={`indicator ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => {
                      setCurrentSlide(index)
                      startAutoSlide()
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Categories Section */}
      <section className="categories-section">
        <div className="container">
          <h2>Shop by Category</h2>
          <div className="categories-grid">
            {categories.map(category => (
              <Link
                key={category.id}
                to={`/products/${category.name}`}
                className="category-card"
              >
                <div className="category-image">
                  {category.image ? (
                    <img src={category.image} alt={category.name} />
                  ) : (
                    <div className="category-placeholder">
                      {category.name.charAt(0)}
                    </div>
                  )}
                </div>
                <h3>{category.name}</h3>
                <p>{category.description}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Home
